import { EntityCatalog } from 'src/app/shared/components/entity-catalog/entity-catalog.types';
import { ianaTimezoneOptions } from 'src/app/core/constants/iana-timezones';
/**
 * Country pack screen, declared as data.
 *
 * Onboarding a country is meant to be a data exercise; this catalog is the operator's entry
 * point for step 1 of that checklist (pack → compliance locks → rule package → document types →
 * prompts → integrations → flow → report template).
 */
export const COUNTRY_PACK_CATALOG: EntityCatalog = {
  title: 'Country Packs',
  singular: 'Country Pack',
  idKey: 'code',
  fields: [
    {
      key: 'code',
      label: 'Pack code',
      kind: 'text',
      inList: true,
      required: true,
      // Immutable because RulePackageVersion rows reference it and are version-pinned onto
      // sessions; renaming would rewrite regulated history.
      immutable: true,
      placeholder: 'INDIA',
      hint: 'Uppercase. A pack code, not an ISO country code.',
    },
    { key: 'display_name', label: 'Display name', kind: 'text', inList: true, required: true },
    {
      key: 'primary_iso2',
      label: 'Primary ISO2',
      kind: 'text',
      inList: true,
      placeholder: 'IN',
      hint: 'ISO 3166-1 alpha-2. Links this pack to the country reference data.',
    },
    {
      key: 'applies_to_iso2',
      label: 'Applies to (ISO2)',
      kind: 'tags',
      placeholder: 'AE, SA, QA',
      hint: 'Every country this pack serves. A regional pack may cover several.',
    },
    { key: 'default_locale', label: 'Default locale', kind: 'text', placeholder: 'en' },
    {
      key: 'supported_locales',
      label: 'Supported locales',
      kind: 'tags',
      placeholder: 'en, hi, ta',
    },
    { key: 'default_currency', label: 'Currency', kind: 'text', inList: true, placeholder: 'INR' },
    {
      key: 'default_timezone',
      label: 'Timezone',
      kind: 'enum',
      searchable: true,
      options: ianaTimezoneOptions(),
      hint: 'IANA timezone used for scheduling and display in this country pack.',
    },
    { key: 'date_format', label: 'Date format', kind: 'text', placeholder: 'DD/MM/YYYY' },    {
      key: 'name_script',
      label: 'Name script',
      kind: 'enum',
      options: ['LATIN', 'ARABIC', 'DEVANAGARI', 'CJK', 'MIXED'],
      hint: 'Drives script-aware name matching in the AI service.',
    },
    {
      key: 'text_direction',
      label: 'Text direction',
      kind: 'enum',
      options: ['LTR', 'RTL'],
      inList: true,
      hint: 'RTL flips the customer portal layout.',
    },
    {
      key: 'status',
      label: 'Status',
      kind: 'enum',
      options: ['ACTIVE', 'BETA', 'DISABLED'],
      inList: true,
      hint: 'A pack cannot be disabled while tenants are assigned to it.',
    },
  ],
};
